import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { searchAPI } from '@/providers/apis/search/search';
import Axios from 'axios';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { SessionService, sessionService } from '@/providers/services/auth/session';
import { competencyAPI } from '@/providers/apis/competency/competency';
import { getSubjectId } from '@/utils/utils';
import { SubjectModel } from '@/models/taxonomy/subject';


@Component({
    name: 'competency-card',
    components: {
        'material-icon': GoogleMaterialIcon,
        'mc-icon': MCIcon,
    },
})

export default class CompetencyCard extends Vue {

    get signatureCollection() {
        return this.learningMapContent.signatureCollections;
    }

    get signatureAssessment() {
        return this.learningMapContent.signatureAssessments;
    }

    get subjectId() {
        return this.activeCompetency ? getSubjectId(this.activeCompetency.competencyCode) : '';
    }

    // ----------------------------------------------------------------------
    // Properties
    @Prop()
    private activeCompetency: any;

    @Prop()
    private prerequisites: any;

    @Prop()
    private learningMapContent: any;

    @Prop()
    private microCompetency: any;

    @Prop()
    private subjects: any;

    private isActive: any = true;
    private competencyDetailsEditForm: any = {
        name: {
            name: 'Short Description',
            field: 'b-form-input',
            modelKey: 'title',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        code: {
            name: 'Code',
            field: 'b-form-input',
            modelKey: 'code',
            modelValue: '',
            validate: { required: true },
        },
        description: {
            name: 'Competency Description',
            field: 'b-textarea',
            modelKey: 'description',
            modelValue: '',
            validate: { required: false },
        },
    };
    private errorMsg =  '';

    private isEdited: boolean = false;

    private editCompetency: any = {title: '', descripion: '', code: '', displayCode: ''};

    private editData: any;

    @Prop()
    private userId!: string;

    @Prop()
    private subject!: SubjectModel;

    private isSubmitted: boolean = false;

    private isEditComp: boolean = false;

    public onChangeInput() {
        if (this.editCompetency.title !== this.editData.competencyName ||
            this.editCompetency.description !== this.editData.competencyStudentDesc ||
            this.editCompetency.code !== this.editData.competencyDisplayCode
        ) {
            this.isEdited = true;
        } else {
            this.isEdited = false;
        }
    }
    private created() {
        const session: any = sessionService.getSession();
        // this.isEditComp = session.permissions.indexOf('EDIT_COMPETENCY_DATA') !== -1;
    }

    // --------------------------------------------------------------------------
    // Actions

    private onChangeTab(action: boolean) {
        this.isActive = action;
    }

    private onClose() {
        this.$emit('onClose');
    }

    private onSelectContent(content: string) {
        this.$emit('onSelectContent', content);
    }

    private onSelectMicro(competency: any) {
        const isActive = competency.isExpanded ? false : true;
        this.$set(competency, 'isExpanded', isActive);
    }

    private onSelectDep(prerequisite: any) {
        const isActive = prerequisite.isExpanded ? false : true;
        this.$set(prerequisite, 'isExpanded', isActive);
    }
    private onEdit(content: any) {
        this.editData = content;
        this.editCompetency.title = content.competencyName;
        this.editCompetency.description = content.competencyStudentDesc;
        this.editCompetency.code = content.competencyDisplayCode;
        this.editCompetency.competencyCode  = content.competencyCode;
        this.$bvModal.show('edit-competency');
    }
    private hideEditSchoolModal() {
        this.$bvModal.hide('edit-competency');
    }

    private onSave() {
        this.isSubmitted = true;
        if (!this.editCompetency.title || !this.editCompetency.description || !this.editCompetency.code) {
            return;
        }
        const params: any = {};
        if (this.editCompetency && this.editCompetency.title !== this.editData.competencyName) {
            params.title = this.editCompetency.title;
        }
        if (this.editCompetency && this.editCompetency.description !== this.editData.competencyStudentDesc) {
            params.studentDesc = this.editCompetency.description ;
        }
        if (this.editCompetency && this.editCompetency.code !== this.editData.competencyDisplayCode) {
            params.code = this.editCompetency.code;
        }
        const frameworkCode = this.subjects.frameworkId;
        competencyAPI.updateTaxonomy(params, frameworkCode, this.subjectId, this.activeCompetency.competencyCode)
        .then((data) => {
            if (data.statusCode === 400) {
                this.errorMsg = data.message;
            } else {
                this.$emit('refreshData', this.activeCompetency.competencyCode);
                this.hideEditSchoolModal();
            }
        });
    }
    private inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }
}
